export default __webpack_public_path__ + "assets/qr-code-advantages-fast-service.bcbe30c2.svg";